<template>
  <b-card>
    <b-tabs card>
      <b-tab title="eKeys" active >
        <b-row>
          <b-col cols="12" md="12">
            <ekey-list :lockId=lockId></ekey-list>
          </b-col>
        </b-row>
      </b-tab>

      <b-tab title="Passcodes">
        <b-row>
          <b-col cols="12" md="12">
            <passcode-list :lockId=lockId></passcode-list>
          </b-col>
        </b-row>
      </b-tab>

      <b-tab title="Log Histories">
        <b-row>
          <b-col cols="12" md="12">
            <history-list :lockId=lockId></history-list>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Lockgroups">
        <b-row>
          <b-col cols="12" md="6">
            <lock-group-for-lock :lockId=lockId></lock-group-for-lock>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </b-card>
</template>
<script>
import EkeyList from '@/views/base/haus/EkeyList'
import PasscodeList from '@/views/base/haus/PasscodeList'
import HistoryList from '@/views/base/haus/HistoryList'
import ManagerListForLock from '@/views/base/haus/ManagerListForLock'
import LockGroupForLock from '@/views/base/haus/LockGroupForLock'
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/locks/listGuest'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'access_token': data.access_token,
      'authorization': data.accessToken
    },
    method: 'POST'
  }).then(res => res.json())
}

export default {
  name: 'lock-detail',
  components: {
    EkeyList,
    PasscodeList,
    HistoryList,
    ManagerListForLock,
    LockGroupForLock
  },
  data () {
    return {
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        email: '',
        name: '',
        phone: '',
        endDate: '',
        startDate: ''
      }
    }
  },
  mounted () {
    this.$data.formData.startDate = constants.getToday()
    this.$data.formData.endDate = constants.getEndDate()
  },
  props: ['locationName', 'locationId', 'locationDescription', 'lockId'],
  methods: {
    submitData (evt) {
      evt.preventDefault()
      postdata(API, this.formData, this.$route.params.lockId)
        .then(data => {
          location.reload()
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LockDetail.vue